import React, { Children } from "react";
import { Card } from "./Home";
import axios from "./general/HttpClient";

import styled from "styled-components";

import { Image, Text, Box, Button } from "grommet";

import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import StyledModal from "./components/StyledModel";
import { Theme } from "./ThemeStore";
import { GenerateCardImage } from "./CardStore";
import reactStringReplace from "react-string-replace";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const CardContainer = styled.default.div`
position: relative;`;
const CardImage = styled.default.div`
position: absolute;
img{
    width: 512px;
}
`;
const CardBorder = styled.default.div`
position: absolute;
img{
    position: absolute;
}`;

const CardResourceContainer = styled.default.div`
position:absolute;
top:10px;
left:10px;
display:flex`;

const CardResource = styled.default.div`
position:relative;
img{
    position: absolute;
}`;

const CardTextBlock = styled.default.div`
position: absolute;
top: 680px;
margin: 15px;
padding: 5px;
background-color: rgba(0, 0, 0, 0.7);
height: 240px;
width: 470px;`;

const RarityColor = (card: Card) => {
    if (card.type == "commander") return "#B10DC9";
    switch (card.rarity?.toLowerCase()) {
        case "common":
            return "#000000";
        case "uncommon":
            return "#6b6b6b";
        case "rare":
            return "#6b4300";
        case "legendary":
            return "#B10DC9";
    }
    return "#000000";
};

const RenderAbilityText = (card: Card) => {
    let knowledgeRegex = /k(\d+)/;
    let artefactRegex = /a(\d+)/;
    let currencyRegex = /c(\d+)/;
    let energyRegex = /e(\d+)/;
    let abilityRegex = /(\(A\):*)/;
    let knowledge = reactStringReplace(card.abilityText, knowledgeRegex, (match, i) => {
        if (match == "0") return null;
        return (
            <Box align="baseline" margin={{ right: "xsmall" }} style={{ display: "inline-flex", position: "relative" }} gap="xsmall" direction="row">
                <Box style={{ backgroundColor: "#0074D9", width: "20px", height: "20px", borderRadius: "100%" }} alignSelf="center"></Box>
                <Text weight={"bold"}>{match}</Text>
            </Box>
        );
    });
    let artefact = reactStringReplace(knowledge, artefactRegex, (match, i) => {
        if (match == "0") return null;
        return (
            <Box align="baseline" margin={{ right: "xsmall" }} style={{ display: "inline-flex", position: "relative" }} gap="xsmall" direction="row">
                <Box style={{ backgroundColor: "#FF851B", width: "20px", height: "20px", borderRadius: "100%" }} alignSelf="center"></Box>
                <Text weight={"bold"}>{match}</Text>
            </Box>
        );
    });
    let currency = reactStringReplace(artefact, currencyRegex, (match, i) => {
        if (match == "0") return null;
        return (
            <Box align="baseline" margin={{ right: "xsmall" }} style={{ display: "inline-flex", position: "relative" }} gap="xsmall" direction="row">
                <Box style={{ backgroundColor: "#2ECC40", width: "20px", height: "20px", borderRadius: "100%" }} alignSelf="center"></Box>
                <Text weight={"bold"}>{match}</Text>
            </Box>
        );
    });
    let energy = reactStringReplace(currency, energyRegex, (match, i) => {
        if (match == "0") return null;
        return (
            <Box align="baseline" margin={{ right: "xsmall" }} style={{ display: "inline-flex", position: "relative" }} gap="xsmall" direction="row">
                <Box style={{ backgroundColor: "#FF4136", width: "20px", height: "20px", borderRadius: "100%" }} alignSelf="center"></Box>
                <Text weight={"bold"}>{match}</Text>
            </Box>
        );
    });
    let ability = reactStringReplace(energy, abilityRegex, (match, i) => {
        if (match == "0") return null;
        return (
            <Box align="end" margin={{ right: "xsmall" }} style={{ display: "inline-flex", position: "relative" }} gap="xsmall">
                <FontAwesomeIcon icon={["fad", "sparkles"]} style={{ position: "relative", top: "5px" }}></FontAwesomeIcon>
            </Box>
        );
    });

    return <div>{ability}</div>;
};

const CardView = ({ card, onUpdate, children, ...props }: { card: Card; onUpdate: Function; props?: any; children?: any }) => {
    const [t, setT] = React.useState(+new Date());
    const [isOpen, setIsOpen] = React.useState(false);
    const [message, setMessage] = React.useState("" as string);
    const [loading, setLoading] = React.useState(false);

    const generateImage = async () => {
        setLoading(true);
        await GenerateCardImage(card.id, setMessage);
        setLoading(false);
    };

    const closeModal = () => setIsOpen(false);

    const download = (card) => {
        let a = document.createElement("a");
        a.href = `/static/card/${card.id}`;
        a.download = card.name + ".png";
        a.click();
    };

    const navigate = useNavigate();
    return (
        <BlankCard borderColor={RarityColor(card)} showBorder={true} showImage={true} borderImageID={card?.theme?.borderImageID} imageID={card?.imageID} onClick={() => setIsOpen(true)}>
            <CardResourceContainer>
                <Box direction="row" gap="small">
                    {card?.cardCost?.knowledge > 0 && (
                        <Box align="center" justify="center" gap="small" direction="row">
                            <div style={{ backgroundColor: "#0074D9", width: "25px", height: "25px", borderRadius: "100%" }}></div>
                            <Text size="large" weight={"bold"}>
                                {card.cardCost.knowledge}
                            </Text>
                        </Box>
                    )}
                    {card?.cardCost?.artifact > 0 && (
                        <Box align="center" justify="center" gap="small" direction="row">
                            <div style={{ backgroundColor: "#FF851B", width: "25px", height: "25px", borderRadius: "100%" }}></div>
                            <Text size="large" weight={"bold"}>
                                {card.cardCost.artifact}
                            </Text>
                        </Box>
                    )}
                    {card?.cardCost?.currency > 0 && (
                        <Box align="center" justify="center" gap="small" direction="row">
                            <div style={{ backgroundColor: "#2ECC40", width: "25px", height: "25px", borderRadius: "100%" }}></div>
                            <Text size="large" weight={"bold"}>
                                {card.cardCost.currency}
                            </Text>
                        </Box>
                    )}
                    {card?.cardCost?.energy > 0 && (
                        <Box align="center" justify="center" gap="small" direction="row">
                            <div style={{ backgroundColor: "#FF4136", width: "25px", height: "25px", borderRadius: "100%" }}></div>
                            <Text size="large" weight={"bold"}>
                                {card.cardCost.energy}
                            </Text>
                        </Box>
                    )}
                </Box>
            </CardResourceContainer>
            {/* <Box background={{ color: "black", opacity: 0.5 }} margin={{ horizontal: 15  + "px", vertical: 610  + "px" }} height="170px"></Box> */}
            <CardTextBlock>
                <Box gap="xsmall">
                    <Box>
                        <Text style={{ textTransform: "uppercase" }} size={"36px"}>
                            {/* <Text style={{ textTransform: "uppercase" }} size={card.name.length > 25 ? "small" : card.name.length > 20 ? "medium" : card.name.length > 10 ? "large" : "xlarge"}> */}
                            {card.name}
                        </Text>
                    </Box>
                    <Text style={{ textTransform: "uppercase" }}>{card.type}</Text>
                    <Box gap="xsmall" align="start">
                        <Text size="large">{RenderAbilityText(card)}</Text>
                    </Box>
                    <Box gap="xsmall">
                        <Text size="large">{card.attackStrategy}</Text>
                    </Box>
                    <Box gap="xsmall" direction="row">
                        <Text size="large">{card.victoryCondition}</Text>
                    </Box>
                    <Box>
                        <Box direction="row" gap="small" style={{ textTransform: "uppercase", position: "absolute", top: "210px", left: "360px" }} round="5px" pad={"small"} background={{ color: "black", opacity: 0.8 }}>
                            {!!card.damage && (
                                <Text size="large">
                                    <FontAwesomeIcon icon={["fad", "sword"]}></FontAwesomeIcon> {card.damage}
                                </Text>
                            )}
                            {!!card.health && (
                                <Text size="large">
                                    <FontAwesomeIcon icon={["fad", "shield-alt"]}></FontAwesomeIcon> {card.health}
                                </Text>
                            )}
                        </Box>
                    </Box>
                    <Box>
                        <Text style={{ textTransform: "uppercase" }} color={"rgb(105, 105, 105)"}>
                            {card.type}
                        </Text>
                    </Box>
                    {children && <Box>{children}</Box>}
                </Box>
            </CardTextBlock>
            <StyledModal isOpen={isOpen} setIsOpen={setIsOpen}>
                <Box width={"medium"} gap="small">
                    {!loading && (
                        <Box gap="small">
                            <Button label="View Card" onClick={() => navigate("/card/" + card.id)}></Button>
                            <Button label="Recreate Image" onClick={generateImage}></Button>
                            <Button label="Download (beta)" onClick={() => download(card)}></Button>
                        </Box>
                    )}
                    {(loading || message) && <Text>{message}</Text>}
                </Box>
            </StyledModal>
        </BlankCard>
    );
};

export const BlankCard = ({ borderColor, showImage, showBorder, imageID, borderImageID, children, ...props }) => {
    return (
        <Box gap="small" {...props} style={{ width: "550px", height: "1000px", overflow: "hidden" }} margin="small" round={"40px"} border={{ size: "20px", color: borderColor || "black" }}>
            <CardContainer>
                {showImage && (
                    <CardImage>
                        <Image src={"/api/images/" + imageID}></Image>
                    </CardImage>
                )}

                {showBorder && (
                    <CardBorder>
                        {showBorder && borderImageID && <Image src={"/api/images/" + borderImageID} width={512}></Image>}
                        {!showBorder || (!borderImageID && <Image src={`/images/borders/blank-border.png`} width={512}></Image>)}
                    </CardBorder>
                )}
                {children}
            </CardContainer>
        </Box>
    );
};

export default CardView;
